import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './components/App';
import AppErrorBoundary from './components/AppErrorBoundary';
import { LanguageProvider } from './context/LanguageContext';

import './index.css';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
